export function firstArrayItem<T extends Array<any> | undefined>(
  nodes?: T,
): (T extends (infer U)[] ? U : T) | undefined {
  if (!nodes || nodes.length === 0) {
    return;
  }

  return nodes[0];
}
